import { useState } from "react";

export default function WelcomeStage({ onComplete, onStartOver, hasProgress }) {
  const [showModal, setShowModal] = useState(false);

  const handleStartOverClick = () => {
    setShowModal(true);
  };

  const confirmStartOver = () => {
    setShowModal(false);
    onStartOver();
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
      <div
        className="card shadow-lg p-5 text-center"
        style={{ maxWidth: "500px" }}
      >
        <h2 className="mb-3 text-primary">Welcome to FinaCraft</h2>
        <p className="lead text-muted mb-4">
          To proceed further, please complete the onboarding process.
          <br />
          This will help us tailor the experience to your needs.
        </p>
        <p className="text-secondary mb-4">
          {hasProgress
            ? "You have some progress saved. Click Resume to continue or Start Over to begin fresh."
            : "Click Start to begin the onboarding process."}
        </p>
        <div className="d-flex gap-3 justify-content-center">
          <button className="btn btn-primary" onClick={onComplete}>
            {hasProgress ? "Resume" : "Start"}
          </button>
          {hasProgress && (
            <button
              className="btn btn-outline-danger"
              onClick={handleStartOverClick}
            >
              Start Over
            </button>
          )}
        </div>
      </div>

      {/* Confirmation Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger">Confirm Start Over</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  This will erase your saved progress and restart onboarding
                  from the beginning. Are you sure you want to continue?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmStartOver}
                >
                  Yes, Start Over
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
